export const Timezones = {
  UTC: 'UTC',
  AR: 'America/Argentina/Buenos_Aires',
  BR: 'America/Sao_Paulo',
  CL: 'America/Santiago',
  MX: 'America/Mexico_City',
  PL: 'Poland',
  TR: 'Turkey',
  US: 'America/Los_Angeles',
  XX: 'SUT Timezone',
}

export const getTimezoneByCountryCode = () => {
  const countryCode = import.meta.env.VITE_COUNTRY_CODE || 'MX';

  return Timezones[countryCode]
}